import moment from 'moment';

const dateTextField = (value) => {
  if (!value || value === '__/__/____') {
    return 'Datum is verplicht';
  }

  const momentDate = moment(value, 'DD/MM/YYYY');
  if (value.includes('_') || !momentDate.isValid()) {
    return 'Datum is onjuist';
  }

  return '';
};

const nonRequiredDateField = (value) => {
  if (!value || value === '__/__/____') {
    return '';
  }

  const momentDate = moment(value, 'DD/MM/YYYY');
  if (value.includes('_') || !momentDate.isValid()) {
    return 'Datum is onjuist';
  }

  return '';
};

const lteNonRequired = (value, than, invalidMessage = 'Startdatum moet vóór einddatum zijn') => {
  const nonRequired = nonRequiredDateField(value);
  if (nonRequired) {
    return nonRequired;
  }

  const momentThan = moment(than, 'DD/MM/YYYY');
  if (!than || than === '__/__/____' || than.includes('_') || !momentThan.isValid()) {
    return '';
  }

  if (!value || value === '__/__/____') {
    return '';
  }

  const momentDate = moment(value, 'DD/MM/YYYY');
  if (!momentDate.isSameOrBefore(momentThan)) {
    return invalidMessage;
  }

  return '';
};

const gteNonRequired = (value, than, invalidMessage = 'Einddatum moet na de startdatum zijn') => {
  const nonRequired = nonRequiredDateField(value);
  if (nonRequired) {
    return nonRequired;
  }
  const momentThan = moment(than, 'DD/MM/YYYY');
  if (!than || than === '__/__/____' || than.includes('_') || !momentThan.isValid()) {
    return '';
  }

  if (!value || value === '__/__/____') {
    return '';
  }

  const momentDate = moment(value, 'DD/MM/YYYY');
  if (!momentDate.isSameOrAfter(momentThan)) {
    return invalidMessage;
  }

  return '';
};

const dateValidators = { dateTextField, nonRequiredDateField, lteNonRequired, gteNonRequired };

export default dateValidators;
